// extracted by mini-css-extract-plugin
export default {"error":"Error_error__hsgNU","errorWrapper":"Error_errorWrapper__Bvh+O","errorLogo":"Error_errorLogo__ESJeA","errorNav":"Error_errorNav__+4RTx"};